export function buildServiceSchema({ siteUrl, siteName }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Infrastructure vidéo temps réel Leagora',
    description:
      'Socle vidéo métier WebRTC intégrable aux parcours professionnels : assistance client, rendez-vous, réunions, live, API vidéo, hébergement France et options on-premise.',
    provider: {
      '@type': 'Organization',
      name: siteName,
    },
    areaServed: {
      '@type': 'Country',
      name: 'France',
    },
    serviceType: 'Infrastructure vidéo métier WebRTC et communication temps réel',
    audience: {
      '@type': 'BusinessAudience',
      audienceType: 'Entreprises, DSI, CTO, intégrateurs, grands comptes, collectivités',
    },
    url: siteUrl,
  };
}

export function buildContentServiceSchema({ siteUrl, siteName, contentPage, pageUrl }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: contentPage.title,
    description: contentPage.description,
    url: pageUrl,
    provider: {
      '@type': 'Organization',
      name: siteName,
      url: siteUrl,
    },
    areaServed: {
      '@type': 'Country',
      name: 'France',
    },
    serviceType: 'Infrastructure vidéo WebRTC',
  };
}
